import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as ivrService from "../../../services/ivr/index";

export const excludeAudienceFromIvrCampaign = createAsyncThunk(
    "ivr/exclude-contacts",
    async (formData, thunkAPI) => {
        try {
            const response = await ivrService.UploadExcludeAudienceData(formData);
            if (response?.success) {
                return response?.data;
            } else {
                return thunkAPI.rejectWithValue(response?.message || "Something went wrong.");
            }
        } catch (err) {
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error.");
        }
    }
);

export const getExcludedAudienceFile = createAsyncThunk(
    "ivr/get-existing-audience-exclude-file",
    async (payload, thunkAPI) => {
        try {
            const response = await ivrService.getExcludedAudienceFileData(payload);
            if (response?.success) {
                return response?.data;
            } else {
                return thunkAPI.rejectWithValue("No Contacts Found to Exclude.");
            }
        } catch (err) {
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error.");
        }
    }
);

const initialState = {
    fileData: [],
    loading: false,
    error: null,
    uploadSuccess: false,
};

const ivrSlice = createSlice({
    name: "ivr",
    initialState,
    reducers: {
        resetIvrState: (state) => {
            state.fileData = [];
            state.loading = false;
            state.error = null;
            state.uploadSuccess = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(excludeAudienceFromIvrCampaign.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.uploadSuccess = false;
            })
            .addCase(excludeAudienceFromIvrCampaign.fulfilled, (state) => {
                state.loading = false;
                state.uploadSuccess = true;
            })
            .addCase(excludeAudienceFromIvrCampaign.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Upload failed";
                state.uploadSuccess = false;
            })
            .addCase(getExcludedAudienceFile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getExcludedAudienceFile.fulfilled, (state, action) => {
                state.loading = false;
                state.fileData = action.payload || [];
            })
            .addCase(getExcludedAudienceFile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch file data";
            });
    },
});

export const { resetIvrState } = ivrSlice.actions;
export const ivrReducer = ivrSlice.reducer;
